const ToastStyle = {
  baseStyle: {
    borderStyle: "solid",
    borderWidth: "2px",
    color: "black",
  },
  variants: {
    success: {
      bg: "white",
    },
    debug: {
      bg: "yellow.700",
    },
  },
};

export default ToastStyle;
